<h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
<div mat-dialog-content>
  <p>{{ content }}</p>
  <fw-delete-reason #deleteReason></fw-delete-reason>
</div>
<div mat-dialog-actions align="end">
  <button test-id="no-button" mat-stroked-button color="primary" (click)="cancel()">
    No
  </button>
  <button test-id="yes-button" mat-flat-button color="primary" [disabled]="!canDelete()" (click)="delete()">
    Yes
  </button>
</div>
